module.exports = __webpack_public_path__ + "img/QRscanning2.6db90558.svg";